import React from "react";

const Down = () => {
  return (
    <svg
      width="40"
      height="66"
      viewBox="0 0 40 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.708 19.854C37.708 9.99351 29.7145 2 19.854 2C9.99351 2 2 9.99351 2 19.854V45.915C2 55.7755 9.99351 63.769 19.854 63.769C29.7145 63.769 37.708 55.7755 37.708 45.915V19.854Z"
        stroke="white"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.9258 15.864V49.825"
        stroke="white"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.0584 41.7L19.8534 49.906L11.6484 41.7"
        stroke="white"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Down;
